import { Routes } from "@angular/router";
import { NoticeComponent } from "./components/notice/notice.component";

export const routes: Routes = [
  {
    path: ":page",
    component: NoticeComponent,
  },
  { path: "**", redirectTo: "conditions-generales" },
];
